import PortalLayout from "../containers/layouts/PortalLayout/PortalLayout";

export const routes = [{
  path: '/',
  component: PortalLayout
}];